export enum PECEnv {
  WebpackDevServer = 'WebpackDevServer',
  Vagrant = 'Vagrant',
  dev = 'dev',
  beta = 'beta',
  production = 'production'
}

export const traceHeaderName = 'X-Amzn-Trace-Id';

export interface IServerTokens {
  accessToken: string;
  complianceReportsUrl: string;
  googleMapsApiKey: string;
  pendoApiKey: string;
  pecEnv: PECEnv;
  [traceHeaderName]: string;
}
